import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f2d51ae0")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BalAsset = _resolveComponent("BalAsset")

  return (_openBlock(), _createBlock("div", {
    class: "relative",
    style: {
      width: `${_ctx.width}px`,
      height: `${_ctx.size}px`
    }
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.addresses, (address, i) => {
      return (_openBlock(), _createBlock(_component_BalAsset, {
        key: i,
        address: address,
        size: _ctx.size,
        class: "token-icon",
        style: {
        left: `${_ctx.leftOffsetFor(i)}px`,
        zIndex: `${20 - i}`,
        width: `${_ctx.size}px`,
        height: `${_ctx.size}px`
      }
      }, null, 8, ["address", "size", "style"]))
    }), 128))
  ], 4))
})